import lessRequire from '../../../config/less-require-resolver';
import { actions, selectors } from './';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import cn from 'classname';
import map from 'lodash/map';
import DOMPurifyCreate from 'dompurify';
const DOMPurify = DOMPurifyCreate(window);

import renderViewsState from '../../shared/render-views-state';
import { translateCategory, getTrafficTypes, getOfferLangs } from '../shared';

import LandingsTransitsTable from '../components/table/landings-transits';
import IdPopup from '../components/popups/IdPopup';
import GeoGoalsTable from '../components/table/geo-goals';
import PromoGallery from '../components/promo-gallery/main';
import RestrictedGeo from '../components/restricted-geo/main';
import Rules from '../components/popups/rules';
import BoosterInfoBanner from '../components/table/booster-info-banner';
import LanguagesSelectFilter from '../components/filters/languages';

lessRequire('modules/offers/single/main.less');

const isRocket = process.env.CPA_ENV === 'rocket';

const Main = renderViewsState(props => {
	const {
		data,
		landings,
		transits,
		columnSorting,
		sortByColumn,
		landingTransitHeaders,
		user,
		lists,
		intl,
		domainLanguagesOptions,
		externalIntegration
	} = props;
	const offerLangs = getOfferLangs(data, lists['landing-languages'], intl);
	const canSeeTransits = props.user.can_see_transits || data.available;
	const isNeedShowIdFrame = data.goals.some(gl => gl.locationCountryCode === 'ID');
	return (
		<div className="single-offer container__with-columns container">
			<div className="column_left container__content">

				<div className="single-offer__section">
					<div className="single-offer__row">
						<div className="single-offer__img">
							<img src={data.image ? data.image : '//placehold.it/160x160'} alt={data.title} />
						</div>

						<div className={cn('single-offer__meta', data.is_exclusive && 'is-exclusive')}>
							<div>
								{!!data.is_new && <button className="button mark font-proxima-nova-semibold">{intl('новинка')}</button>}
								{!!data.access_on_request && <button className="button mark access font-proxima-nova-semibold">
									{intl('по запросу')}</button>}
								<h3 className="font-proxima-nova-bold">{data.title}</h3>

								{data.subtitle && <p className="subtitle">{data.subtitle}</p>}
							</div>
							<div className="single-offer__meta-info-list">
								{!isRocket && (
									<div className="single-offer__meta-info">
										<span>{intl('Сайт')}</span>
										<a href={`http://${data.domain}`} target="_blank">{data.domain}</a>
									</div>
								)}

								<div className="single-offer__meta-info category">
									<span>{intl('Категория')}</span>
									<span className="category__name">
										{buildLinkToOffer(
											!isRocket ? translateCategory(data.category, lists) : {
												id: data.category_rp.id,
												text: data.category_rp[`name_${intl.language === 'ru' ? 'ru' : 'en'}`]
											}
										)}
									</span>
								</div>

								{offerLangs.offerLangsLen > 0
									? (<div className="single-offer__meta-info offer-langs">
										{offerLangs.offerLangsLen > 1
											? (<div>
												<span className="count">{offerLangs.offerLangsLen}</span>
												<div className="text">{offerLangs.offerLangsWord}</div>
												<div className="hover-popup">
													{ map(offerLangs.offerLangs, l => (
														<span key={`${data.id}${l}`} className="lang">{l}</span>
													))
													}
												</div>
											</div>)
											: (
												<div className="text">{offerLangs.offerLangs[0]}</div>
											)}
									</div>)
									: null}
							</div>
						</div>
					</div>
					{isNeedShowIdFrame && <IdPopup intl={intl} managerData={props.managerData}/>}

					<div className="single-offer__row rule-offer__row">
						<div className="single-offer__desc-type font-proxima-nova-bold">
							<span className="icon-full-desc" />
							<span className="text font-proxima-nova-semibold">{intl('Правила')}</span>
						</div>
						<p
							className="single-offer__desc offer-rules__scroll"
							dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.rules) }}
						/>
					</div>
				</div>

				{ Array.isArray(data.goals) && (
					<div className="single-offer__section">
						<div className="single-offer__geo">
							<h3 className="font-proxima-nova-bold">{intl('География')}</h3>
							<GeoGoalsTable
								data={data.goals}
								single_offer_id={props.params && props.params.id}
								intl={intl}
								boost={props.boost}
								user={user}
								offer={data}
								toggleRules={props.toggleRules} />

							<BoosterInfoBanner
								intl={intl} userBoostInfo={user.boost_info} offerData={data}
								shouldShowBooster={true}
							/>
						</div>
					</div>
				) }

				{ !externalIntegration && landings && landings.data.length > 0 && (
					<div className="single-offer__section">
						<div className="single-offer__land">
							<div className="single-offer__land-title clearfix">
								<h3 className="font-proxima-nova-bold">{intl('Лендинги')}</h3>
								<div className="filters">
									<LanguagesSelectFilter
										form="landingLanguagesFilter"
										intl={intl}
										languagesOptions={domainLanguagesOptions.landing} />
								</div>
							</div>

							<LandingsTransitsTable
								type="landings"
								data={landings.data}
								langList={lists['landing-languages']}
								tableHeaders={landingTransitHeaders}
								columnSorting={columnSorting.landing}
								sortByColumn={sortByColumn.bind(null, 'landing')}
								showMore={props.pagination().showMore}
								isCanNotMoveToNext={landings.isCanNotMoveToNext}
								canSeeTransits={canSeeTransits}
								intl={intl}
							/>
						</div>

						{!isRocket && (
							<div className="new-landing-transit-link">
								<span className="sad-smile-icon" />
								<span>
									{intl('Не нашли нужные лендинг или транзитку? Отправьте')}
									{' '}
									<a href={`tickets/request/new-landing/${data.id}/`} target="_blank">
										{intl('запрос на добавление!')}
									</a>
								</span>
							</div>
						)}

					</div>
				)}

				{
					transits && transits.data.length > 0 && !canSeeTransits && process.env.CPA_ENV === 'everad' &&
					<HiddenPromoMessage intl={intl}/>
				}

				{transits && transits.data.length > 0 && (
					<div className="single-offer__section">
						<div className="single-offer__land">
							<div className="single-offer__land-title clearfix">
								<h3 className="font-proxima-nova-bold">
									{intl('Транзитки')}
								</h3>
								<div className="filters">
									<LanguagesSelectFilter
										form="transitLanguagesFilter"
										intl={intl}
										languagesOptions={domainLanguagesOptions.transit} />
								</div>

							</div>

							<LandingsTransitsTable
								type="transits"
								data={transits.data}
								langList={lists['landing-languages']}
								tableHeaders={landingTransitHeaders}
								columnSorting={columnSorting.transit}
								sortByColumn={sortByColumn.bind(null, 'transit')}
								showMore={props.pagination().showMore}
								isCanNotMoveToNext={transits.isCanNotMoveToNext}
								canSeeTransits={canSeeTransits}
								intl={intl}
							/>
						</div>

						{!isRocket && (
							<div className="new-landing-transit-link">
								<span className="sad-smile-icon" />
								<span>
									{intl('Не нашли нужные лендинг или транзитку? Отправьте')}
									{' '}
									<a href={`tickets/request/new-landing/${data.id}/`} target="_blank">
										{intl('запрос на добавление!')}
									</a>
								</span>
							</div>
						)}
					</div>
				)}
			</div>
			<div className="column_right">
				<div className="meta">
					<div className="meta__control-btn">

						{addOfferControl(props)}

						{props.data && props.data.status !== 'stopped' && isAccessGranted(props) &&
						<Link className="button yellow-btn font-proxima-nova-semibold" to={`campaigns/new/${data.id}/`}>
							{intl('Создать поток')}
						</Link>}

						{isWaitingForActivation(props) &&
						<p className="control-btn__info font-proxima-nova-semibold">{intl('Ожидается активация')}</p>}

						{isAccessRejected(props) &&
						<p className="control-btn__info font-proxima-nova-semibold">{intl('Заявка отклонена')}</p>}
					</div>

					{!isRocket && (
						<div className="meta__bottom clearfix">
							<div className="meta__bottom-info">
								<span className="icon-hold" />
								<div className="text">
									<p>{intl('Холд')}</p>
									<span>0 {intl('дней')}</span>
								</div>
							</div>
							<div className="meta__bottom-info">
								<span className="icon-post-click" />
								<div className="text">
									<p>{intl('Постклик')}</p>
									<span>30 {intl('дней')}</span>
								</div>
							</div>
						</div>
					)}
				</div>

				{isRocket && (
					<RestrictedGeo intl={props.intl} data={data.goals} />
				)}

				<PromoGallery  {...props} />

				{!isRocket && (
					<RestrictedGeo intl={props.intl} data={data.goals} />
				)}

				<div className="traffic-source container__content">
					<div className="container__content-title">
						<h2 className="font-proxima-nova-bold">{intl('Источники трафика')}</h2>
					</div>

					{getTrafficTypes(intl).map((item, i) => (
						<span key={i} className={`traffic-source__type ${item.isNotAllowed ? 'not-active' : ''}`}>
							{item.text}
						</span>
					))}

				</div>
			</div>

			{ <Rules {...props} />	}
		</div>
	);
});

const addOfferControl = props => {
	if (props.data && !props.data.available && !props.data.offer_access_thread_id) {
		return (
			<button className="button yellow-btn font-proxima-nova-semibold" onClick={e => props.toggleRules(props.data.id)}>
				{(props.user.level === props.affiliateLevels.noob || props.data.access_on_request)
					? props.intl('Запросить доступ')
					: props.intl('Подключить оффер')
				}
			</button>
		);
	}
};

addOfferControl.propTypes = {
	data: PropTypes.object,
	user: PropTypes.object,
	addOffer: PropTypes.func,
	intl: PropTypes.func,
	affiliateLevels: PropTypes.object,
	toggleRules: PropTypes.func
};

const HiddenPromoMessage = ({intl}) => {
	return (
		<div className="single-offer__section">
			<div className="single-offer__land">
				<div className="single-offer__land-title clearfix">
					<h3 className="font-proxima-nova-bold">
						{intl('Свяжитесь с менеджером для просмотра транзитки')}
					</h3>
				</div>
			</div>
		</div>
	);
};

HiddenPromoMessage.propTypes = {
	intl: PropTypes.func
};

const isAccessGranted = props => props.data && props.data.available;
const isWaitingForActivation = props =>
	props.data && !props.data.available && props.data.offer_access_thread_id && !props.data.offer_access_thread_closed_at;
const isAccessRejected = props =>
	props.data && !props.data.available && props.data.offer_access_thread_id && props.data.offer_access_thread_closed_at;

const buildLinkToOffer = entity => {
	const url = qs.stringify({
		category: entity
	});

	return <Link to={`/offers/public/?${url}`}>{entity.text}</Link>;
};

export default connect(
	state => ({
		data: selectors.getData(state),
		managerData: selectors.getManagerData(state),
		news: selectors.getNews(state),
		newsTypes: selectors.getNewsTypes(state),
		openedNewsId: selectors.getOpenedNewsId(state),
		openedNewsOffers: selectors.getOpenedNewsOffers(state),
		landingTransitHeaders: selectors.getLandingTransitHeaders(state),
		columnSorting: selectors.getColumnSorting(state),
		landings: selectors.getLandings(state),
		transits: selectors.getTransits(state),
		affiliateLevels: selectors.getAffiliateLevels(),
		modalGallery: selectors.getModalGallery(state),
		intl: selectors.getIntl(state),
		lists: selectors.getLists(state),
		user: selectors.getUser(state),
		promoGalleryData: selectors.getPromoGalleryData(state),
		error: selectors.getError(state),
		offerInfo: selectors.getOfferInfo(state),
		domainLanguagesOptions: selectors.getOfferDomainsLanguagesList(state),
		externalIntegration: selectors.getExternalIntegration(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/single/main.js